

// export default Contact;
import React, { useState } from 'react';
import API from '../api';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './contact.css';

// Helper: Validate Email
const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", description: "" });
  const [submitted, setSubmitted] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
        if (phoneError) setPhoneError("");
      }
    } else {
      setFormData({ ...formData, [name]: value });
      if (name === "email" && emailError) setEmailError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;

    // Validation
    if (!validateEmail(formData.email)) {
      setEmailError("Please enter a valid email address.");
      isValid = false;
    }
    if (formData.phone.length !== 10) {
      setPhoneError("Phone number must be exactly 10 digits.");
      isValid = false;
    }

    if (!isValid) return;

    try {
      await API.post("/contact", formData);
      setFormData({ name: "", email: "", phone: "", description: "" });
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error("Error Submitting:", error);
      alert("Failed to Submit. Please try again.");
    }
  };

  return (
    <>
      <Header />
      
      <div className="cnt-page-wrapper" id='contact-section'>
        
        {/* Background Blobs for Elegance */}
        <div className="cnt-bg-decor decor-top"></div>
        <div className="cnt-bg-decor decor-bottom"></div>

        <div className="cnt-card">
          <h1 className="cnt-title">Get in Touch</h1>
          <p className="cnt-subtitle">
            Have questions about our classes or products?<br/>
            We'd love to hear from you on your Satvic journey.
          </p>

          <form onSubmit={handleSubmit} className="cnt-form" noValidate>
            
            <div className="cnt-input-group">
              <input
                type="text"
                name="name"
                className="cnt-input"
                placeholder="Your Full Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="cnt-input-group">
              <input
                type="tel"
                name="phone"
                className="cnt-input"
                placeholder="Phone Number (10 digits)"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
              {phoneError && <p className="cnt-error-msg">{phoneError}</p>}
            </div>

            <div className="cnt-input-group">
              <input
                type="email"
                name="email"
                className="cnt-input"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {emailError && <p className="cnt-error-msg">{emailError}</p>}
            </div>

            <div className="cnt-input-group">
              <textarea
                name="description"
                className="cnt-textarea"
                placeholder="How can we help you today?"
                value={formData.description}
                onChange={handleInputChange}
                required
                rows={4}
              />
            </div>

            <button type="submit" className="cnt-submit-btn">
              Send Message
            </button>
          </form>

          {submitted && (
            <div className="cnt-success-msg">
              Thank you! We have received your message.
            </div>
          )}
        </div>
      </div>

      <HomeFooter />
    </>
  );
};

export default Contact;